// @flow
import React from 'react';
import { linkVertical as d3linkVertical } from 'd3-shape';
import commonSvg from '../../static/common.svg';
import Node from './Node';
import { BoxShadow } from './BoxShadow';
import { ENTRY_TYPE, EXIT_TYPE } from '../constants/ApiTypes';

const commonHtml = {
  __html: commonSvg
};

type Props = {
  nodesList: any,
  linksList: any,
  creativeData: Object,
  commonData: Object,
  selectedNode: number,
  editable: boolean
};

const linkPathGen = d3linkVertical()
  .x(d => d.x)
  .y(d => d.y);

const calculateSVGSize = nodes => {
  const xs = nodes.map(n => n.props.node.x);
  const ys = nodes.map(n => n.props.node.y);
  const widths = nodes.map(n => n.props.node.data.width);
  const heights = nodes.map(n => n.props.node.data.height);

  const mostRight = widths.map((w, i) => xs[i] + w);
  const mostleft = widths.map((w, i) => xs[i] - w);
  const mostDown = heights.map((h, i) => ys[i] + h);

  const top = Math.max(...heights, 0);
  const left = Math.min(...mostleft, 0);
  const width = Math.abs(left) + Math.max(...mostRight, 0);
  const height = Math.max(...mostDown, 0);

  return {
    top,
    left,
    width,
    height
  };
};

function Tree(props: Props) {
  const {
    nodesList,
    linksList,
    selectedNode,
    creativeData,
    commonData,
    editable
  } = props;

  const nodes = nodesList.map(node => (
    <Node
      creativeData={creativeData}
      commonData={commonData}
      key={node.data.id}
      node={{
        ...node,
        data: { ...node.data, selected: selectedNode === node.data.name }
      }}
      editable={editable}
    />
  ));

  const links = linksList.map(link => {
    let path = { ...link };

    if (link.source.data.node_type === ENTRY_TYPE) {
      return null;
    }

    if (link.target.data.node_type === EXIT_TYPE) {
      return null;
    }

    path = {
      ...path,
      source: {
        ...path.source,
        y: path.source.y + path.source.data.height
      }
    };
    return (
      <path
        key={`${link.source.data.id}-${link.target.data.id}`}
        className="link"
        d={linkPathGen(path)}
        fill="transparent"
        stroke="#C8C8CC"
        strokeWidth="1"
      />
    );
  });

  const svgSize = calculateSVGSize(nodes);
  return (
    <div
      style={{
        display: 'flex',
        overflow: 'auto',
        maxHeight: 'calc(100vh - 132px)' // 132px is the height of all dom elements (headers) above this dom node
      }}
    >
      <div
        id="svg-container"
        dangerouslySetInnerHTML={commonHtml} // eslint-disable-line react/no-danger
      />
      <svg
        style={{ margin: '0 auto' }}
        width={svgSize.width}
        height={svgSize.height}
        viewBox={`${svgSize.left}, ${svgSize.top + 30}, ${svgSize.width}, ${
          svgSize.height
        }`}
        xmlns="http://www.w3.org/2000/svg"
      >
        <BoxShadow />
        <g>
          {links}
          {nodes}
        </g>
      </svg>
    </div>
  );
}

export default Tree;



// WEBPACK FOOTER //
// ./src/components/Tree.jsx